import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import DocumentPreviewDetailContMain from "presentation/view/container/DocumentPreview/DocumentPreviewDetailContMain";

CommonEntrypoint(<DocumentPreviewDetailContMain/>)